import { ADD_ALERTS, ALERTS_API_REQUEST, ALERTS_API_SUCCESS, ALERTS_API_FAILURE } from '../actions/actionTypes';

const initialState = {
  count: null,
  results: [],
  alertsLoaded: false,
  alertsLoading: false,
  error: null,
};

export default function getAlerts(state = initialState, action) {
  switch (action.type) {
    case ALERTS_API_REQUEST: {
      return {
        ...state,
        alertsLoading: true,
        alertsLoaded: false,
      };
    }
    case ALERTS_API_SUCCESS: {
      return {
        ...state,
        alertsLoading: false,
        error: null,
      };
    }
    case ADD_ALERTS: {
      const { count, results } = action.payload;
      return {
        ...state,
        count,
        results,
        alertsLoaded: true,
      };
    }
    case ALERTS_API_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    default:
      return state;
  }
}
